import { AxiosError } from "axios";

export const GENERIC_SERVER_ERROR_MESSAGE =
  "Ocurrió un error al procesar la solicitud.";
export const NETWORK_ERROR_MESSAGE =
  "No fue posible conectar con el servidor.";

export interface AppHttpError {
  name: "AppHttpError";
  message: string;
  status: number;
  statusText: string;
  method: string;
  url: string;
  data: any;
  traceId?: string;
  response: {
    status: number;
    statusText: string;
    data: any;
    headers?: Record<string, unknown>;
  };
}

function toHeadersObject(headers: any): Record<string, unknown> {
  if (!headers) return {};

  const result: Record<string, unknown> = {};
  Object.keys(headers).forEach((key) => {
    result[key.toLowerCase()] = headers[key];
  });
  return result;
}

function nonEmptyString(value: any): string | undefined {
  return typeof value === "string" && value.trim()
    ? value.trim()
    : undefined;
}

function getTraceId(data: any, headers: Record<string, unknown>): string | undefined {
  const bodyTraceId =
    data && typeof data === "object" ? nonEmptyString(data.traceId) : undefined;

  return (
    bodyTraceId ||
    nonEmptyString(headers["x-trace-id"]) ||
    nonEmptyString(headers["x-correlation-id"]) ||
    nonEmptyString(headers["trace-id"])
  );
}

function getFunctionalMessage(data: any): string | undefined {
  const stringResponse = nonEmptyString(data);
  if (stringResponse) return stringResponse;
  if (!data || typeof data !== "object") return undefined;

  return (
    nonEmptyString(data.detail) ||
    nonEmptyString(data.message) ||
    nonEmptyString(data.title)
  );
}

function appendTraceId(message: string, traceId?: string): string {
  return traceId
    ? `${message} Código de seguimiento: ${traceId}`
    : message;
}

export function toAppHttpError(error: AxiosError): AppHttpError {
  const response = error && error.response ? error.response : undefined;
  const config = error && error.config ? error.config : undefined;
  const status = response && typeof response.status === "number" ? response.status : 0;
  const statusText = response && response.statusText ? response.statusText : "";
  const method =
    config && config.method ? String(config.method).toUpperCase() : "GET";
  const url = config && config.url ? String(config.url) : "";
  const data = response && typeof response.data !== "undefined" ? response.data : null;
  const headers = toHeadersObject(response ? response.headers : undefined);
  const traceId = getTraceId(data, headers);

  let message: string;
  if (status >= 500) {
    message = appendTraceId(GENERIC_SERVER_ERROR_MESSAGE, traceId);
  } else if (status >= 400) {
    message =
      getFunctionalMessage(data) ||
      nonEmptyString(error && error.message) ||
      "No fue posible completar la operación.";
  } else if (!response) {
    message = NETWORK_ERROR_MESSAGE;
  } else {
    message =
      nonEmptyString(error && error.message) ||
      "No fue posible completar la operación.";
  }

  return {
    name: "AppHttpError",
    message,
    status,
    statusText,
    method,
    url,
    data,
    traceId,
    response: {
      status,
      statusText,
      data,
      headers
    }
  };
}
